import { render, staticRenderFns } from "./OzListRow.vue?vue&type=template&id=6329a68b&"
import script from "./OzListRow.vue?vue&type=script&lang=ts&"
export * from "./OzListRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports